import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TimeChangeRequestLookupComponent } from './time-change-request-lookup.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
    
  ],
  declarations: [TimeChangeRequestLookupComponent],
  exports: [TimeChangeRequestLookupComponent]
})
export class TimeChangeRequestLookupModule { }
